import { Button, Drawer, Flex, Select } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Hamburger, NavbarContainer, NavigationContent } from "../styled-components/navbar";
import { ReactElement, useState } from "react";

const Navbar = (props: any) => {
    const { title, hidden, legal, login, nIDRestaurant, setUser } = props;
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [show, setShow] = useState<boolean>(false);

    const redirectToHome = () => {
        navigate(`/?nIDRestaurant=${nIDRestaurant}`);
    }

    const redirectToMenu = () => {
        navigate(`/home?nIDRestaurant=${nIDRestaurant}`);
    }
    
    const redirectToBook = () => {
        navigate('/book', { state: { nIDRestaurant: nIDRestaurant }} );
    }
    
    const redirectToRestaurants = () => {
        navigate('/');
    }

    const contentNavigation = (): ReactElement => (
        <>
            { !hidden && <div
                onClick={redirectToHome}
                style={{ color: 'white', cursor: 'pointer', fontSize: '0.8rem', fontFamily: 'Roboto-Thin' }}
            >
                { t('navbar.home') }
            </div> }
            { !hidden && <div
                onClick={redirectToRestaurants}
                style={{ color: 'white', cursor: 'pointer', fontSize: '0.8rem', fontFamily: 'Roboto-Thin' }}
            >
                { t('navbar.restaurants') }
            </div> }
            { !hidden && !legal && <div
                onClick={redirectToMenu}
                style={{ color: 'white', cursor: 'pointer', fontSize: '0.8rem', fontFamily: 'Roboto-Thin' }}
            >
                { t('navbar.menu') }
            </div> }
            { !hidden && !legal && <div
                onClick={redirectToBook}
                style={{ color: 'white', cursor: 'pointer', fontSize: '0.8rem', fontFamily: 'Roboto-Thin' }}
            >
                { t('navbar.reservations') }
            </div> }
            <Select
                value={i18n.language}
                className='language-dropdown without-borders'
                onChange={(value: string) => {
                    sessionStorage.setItem('lang', value);
                    i18n.changeLanguage(value);
                    setShow(false);
                }}
                style={{ minWidth: 120 }}
            >
                <Select.Option value="ca"> 🇪🇸 { t('language.catalan') } </Select.Option>
                <Select.Option value="es"> 🇪🇸 { t('language.spanish') } </Select.Option>
                <Select.Option value="en"> 🇬🇧 { t('language.english') } </Select.Option>
                <Select.Option value="fr"> 🇫🇷 { t('language.french') } </Select.Option>
                <Select.Option value="de"> 🇩🇪 { t('language.german') } </Select.Option>
            </Select>
            { login &&
                <Button
                    type="text"
                    danger
                    onClick={() => setUser(null)}
                    style={{ fontSize: '0.8rem', fontFamily: 'Roboto-Thin' }}
                >
                    { t('buttons.logout') }
                </Button>
            }
        </>
    );
    return (
        <NavbarContainer>
            <Flex justify={hidden ? "flex-end": "space-between"} align="center" style={{ marginInline: 20, height: '100%' }}>
                { !hidden && <div style={{ fontSize: '2rem', fontFamily: 'Suburban', color: 'white', textTransform: 'uppercase' }}> { title ?? 'AMS' } </div> }
                <Hamburger color="white" onClick={() => setShow(!show) } />
                { show && 
                    <Drawer
                        onClose={() => setShow(false)}
                        open={show}
                        style={{ backgroundColor: 'black', color: 'white' }}
                        closeIcon={false}
                    >
                        <Flex vertical align="center" justify="flex-start" gap={50} style={{ marginTop: 50}}>
                            { contentNavigation() }
                        </Flex>
                    </Drawer>
                }
                { !show &&
                    <NavigationContent align="center" justify="space-evenly" style={{ width: '50%' }}>
                        { contentNavigation() }
                    </NavigationContent>
                }
            </Flex>
        </NavbarContainer>
    )
}

export default Navbar